<template>
  <div>
    <p class="title">
      <img src="/official_mobile/static/img/home/language.png">{{ $t('common.p16') }}
    </p>
    <div class="lang">
      <div class="lang-item">
        <p
          :class="{ hightlight: language == 'en'}"
          @click="setLanguage('en')"
        >
          {{ $t('common.p17') }}
        </p>
        <p
          :class="{ hightlight: language == 'pt'}"
          @click="setLanguage('pt')"
        >
          {{ $t('common.p18') }}
        </p>
      </div>
      <div class="lang-item">
        <p
          :class="{ hightlight: language == 'ru'}"
          @click="setLanguage('ru')"
        >
          {{ $t('common.p19') }}
        </p>
        <p
          :class="{ hightlight: language == 'es'}"
          @click="setLanguage('es')"
        >
          {{ $t('common.p20') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  computed: {
    language () {
      return this.$i18n.locale
    }
  },
  methods: {
    setLanguage (lang) {
      if(lang != this.language) {
        Cookies.set('language', lang, { expires: 1000 })
        location.reload()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  img {
    width: 39px;
    margin-right: 10px;
    vertical-align: middle;
    display: inline-block;
  }
}
.lang {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .lang-item {
    display: flex;
    width: 280px;
    height: 120px;;
    color: #717171;
    justify-content: space-around;
    flex-direction: column;
    align-items: flex-start;
    .hightlight {
      color: #fff;
    }
    p {
      margin: 16px 0px;
    }
  }
}
</style>
